import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuList from '@material-ui/core/MenuList';
import logo from '../../common/images/fpl_logo.png';
import PropTypes from 'prop-types';
import { history } from '../../../redux/history';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    fontFamily: 'Arial',
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: '#0073a8',
  },
  title: {
    flexGrow: 1,
  },
  toolbarButtons: {
    marginLeft: 'auto',
    fontFamily: 'Arial',
  },
  colorPrimary: {
    color: '#0073a8',
  },
  bar: {
    backgroundColor: '#fff',
    boxShadow: 'none',
  },
}));

export function Header(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleProfile = event => {
    event.preventDefault();
    let data = props.currentUser;
    history.push('/profile', { data });
  };

  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.bar}>
        <Toolbar>
          <Link className="navbar-brand" to="/" onClick={props.logout}>
            <img alt="Florida Power-2 &amp; Light logo" src={logo} />
          </Link>
          {props.isAuthenticated && (
            <div className={classes.toolbarButtons}>
              <IconButton
                ref={anchorRef}
                edge="end"
                className={classes.menuButton}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleToggle}
                color="primary"
              >
                <AccountCircle />
                <Typography>
                  &nbsp;{props.currentUser.firstName}&nbsp;
                  {props.currentUser.lastName}
                </Typography>
              </IconButton>
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList
                          autoFocusItem={open}
                          id="menu-list-grow"
                          onKeyDown={handleListKeyDown}
                        >
                          <MenuItem onClick={handleProfile}>Profile</MenuItem>
                          <MenuItem onClick={props.logout}>Logout</MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}
Header.propTypes = {
  currentUser: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  logout: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  appLoaded: PropTypes.bool,
};

export default Header;
